module.exports = __webpack_public_path__ + "static/img/8.282f076.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/sp/8.png
// module id = Vy+t
// module chunks = 0